import { useTranslation } from "react-i18next";
import { SeatStatus } from "../../features/sessions/enums/SeatStatus";

interface PortalSeatStatusChipProps {
  status: SeatStatus;
}

/** "Booked" (green) or "Waiting for confirmation" (secondary) for a member's Occurrence seat. */
const PortalSeatStatusChip = ({ status }: PortalSeatStatusChipProps) => {
  const { t } = useTranslation();

  return status === SeatStatus.Confirmed ? (
    <span className="rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-900/30 dark:text-green-300">
      {t("portal.booking.confirmed", "Booked")}
    </span>
  ) : (
    <span className="rounded-full bg-secondary-90 px-2 py-0.5 text-xs font-medium text-secondary-20 dark:bg-secondary-20 dark:text-secondary-90">
      {t("portal.booking.requested", "Waiting for confirmation")}
    </span>
  );
};

export default PortalSeatStatusChip;
